import { createContext } from "react";

export const NitroContext = createContext(null);
